import { Routes, Route } from 'react-router-dom'
import { config } from '@/config'
import Home from './pages/Home'
import Booking from './pages/Booking'
import BookingSuccess from './pages/BookingSuccess'
import OrderSearch from './pages/OrderSearch'
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import AdminAppointments from './pages/admin/Appointments'
import AdminServices from './pages/admin/Services'
import AdminBeauticians from './pages/admin/Beauticians'
import AdminSettings from './pages/admin/Settings'
import AdminAnnouncements from './pages/admin/Announcements'
import AdminLayout from './components/admin/Layout'
import BottomNav from './components/BottomNav'

function App() {
  const enablePublicPages = config.enablePublicPages
  
  return (
    <div className="min-h-screen bg-primary-50">
      <Routes>
        {/* 公共页面 - 仅在启用时显示 */}
        {enablePublicPages && (
          <>
            <Route path="/" element={<><Home /><BottomNav /></>} />
            <Route path="/booking" element={<><Booking /><BottomNav /></>} />
            <Route path="/booking/success" element={<><BookingSuccess /><BottomNav /></>} />
            <Route path="/search" element={<><OrderSearch /><BottomNav /></>} />
          </>
        )}
        
        {/* 管理后台 - 始终显示 */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/admin/appointments" element={<AdminLayout><AdminAppointments /></AdminLayout>} />
        <Route path="/admin/services" element={<AdminLayout><AdminServices /></AdminLayout>} />
        <Route path="/admin/beauticians" element={<AdminLayout><AdminBeauticians /></AdminLayout>} />
        <Route path="/admin/announcements" element={<AdminLayout><AdminAnnouncements /></AdminLayout>} />
        <Route path="/admin/settings" element={<AdminLayout><AdminSettings /></AdminLayout>} />
        
        {/* 首页重定向 */}
        {!enablePublicPages && (
          <Route path="/" element={<><AdminDashboard /><BottomNav /></>} />
        )}
      </Routes>
    </div>
  )
}

export default App
